import React, {useMemo} from 'react';
import {Layout, Menu} from 'antd';
import {connect} from 'react-redux';
import {NAV_TYPE_SIDE, SIDE_NAV_DARK, SIDE_NAV_LIGHT, SIDE_NAV_WIDTH,} from 'constants/ThemeConstant';
import {Scrollbars} from 'react-custom-scrollbars';
import Logo from './Logo';
import utils from 'utils';
import Utils from 'utils';
import useDocsNavPages from 'hooks/useDocsNavPages';
import {Link, useLocation} from 'react-router-dom';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import IntlMessage from 'components/util-components/IntlMessage';
import DashboardIcon from 'components/icons/Dashboard';
import {APP_PREFIX_PATH} from 'configs/AppConfig';

const { Sider } = Layout;

// const toKebabCase = (string) => {
//   return string.replaceAll(' ', '-').toLowerCase();
// };

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const DocumentationSideNavContent = (props) => {
  const { pages } = useDocsNavPages();
  const location = useLocation();
  const { sideNavTheme, hideGroupTitle, localization, onMobileNavToggle } =
    props;
  const isMobile = !Utils.getBreakPoint(useBreakpoint()).includes('lg');
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  const openedId = useMemo(
    () => location.pathname.split('/').pop(),
    [location]
  );

  return (
    <>
      <Menu
        theme={sideNavTheme === SIDE_NAV_LIGHT ? 'light' : 'dark'}
        mode="inline"
        style={{ height: '100vh', borderRight: 0 }}
        selectedKeys={[openedId.toString()]}
        className={`d-flex flex-column ${
          hideGroupTitle ? 'hide-group-title' : ''
        } ${isMobile ? 'mobile-nav-menu' : ''}`}
      >
        <Menu.Item className="application-link">
          <DashboardIcon className="icon" />
          Back to Application
          <Link
            onClick={() => closeMobileNav()}
            to={`${APP_PREFIX_PATH}/dashboard`}
          />
        </Menu.Item>
        {pages?.map((page) => (
          <Menu.Item key={page.id}>
            <span>{setLocale(localization, page.title)}</span>
            <Link onClick={() => closeMobileNav()} to={`/docs/${page.id}`} />
          </Menu.Item>
        ))}

        <div className="flex-fill" />
      </Menu>
    </>
  );
};

export const DocumentationSideNav = ({
  navCollapsed,
  sideNavTheme,
  headerNavColor,
  routeInfo,
  hideGroupTitle,
  localization = true,
  currentTheme,
}) => {
  const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === 'dark' ? '#00000' : '#ffffff'
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  return (
    <Sider
      className={`docs-side-nav ${
        sideNavTheme === SIDE_NAV_DARK ? 'side-nav-dark' : ''
      }`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed}
      collapsedWidth={0}
    >
      <Logo logoType={navMode} className="mb-3" />
      <Scrollbars autoHide>
        <DocumentationSideNavContent type={NAV_TYPE_SIDE} {...props} />
      </Scrollbars>
    </Sider>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme, headerNavColor, currentTheme } = theme;
  return { navCollapsed, sideNavTheme, headerNavColor, currentTheme };
};

export default connect(mapStateToProps)(DocumentationSideNav);
